import { render } from "./CreateMedicationType.vue?vue&type=template&id=74e51fba&scoped=true"
import script from "./CreateMedicationType.vue?vue&type=script&lang=js"
export * from "./CreateMedicationType.vue?vue&type=script&lang=js"

import "./CreateMedicationType.vue?vue&type=style&index=0&id=74e51fba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74e51fba"]])

export default __exports__